"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function fillParameterWithDDO(parameter, ddo) {
    var getValue = function (name) {
        switch (name) {
            case 'amount':
            case 'price':
                return String(ddo.findServiceByType('metadata').attributes.main.price);
            case 'assetId':
            case 'documentId':
            case 'documentKeyId':
                return ddo.shortId();
            case 'rewardAddress':
                return ddo.publicKey[0].owner;
        }
        return '';
    };
    var value = getValue(parameter.name.replace(/^_/, ''));
    return __assign(__assign({}, parameter), { value: value });
}
function fillConditionsWithDDO(conditions, ddo) {
    return conditions.map(function (condition) { return (__assign(__assign({}, condition), { parameters: condition.parameters.map(function (parameter) { return (__assign({}, fillParameterWithDDO(parameter, ddo))); }) })); });
}
exports.fillConditionsWithDDO = fillConditionsWithDDO;
//# sourceMappingURL=DDOHelpers.js.map